var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { Tooltip } from 'react-leaflet';
const MapLeafletTransportParkingTooltip = (props) => {
    const { value } = props, rest = __rest(props, ["value"]);
    return (React.createElement(Tooltip, Object.assign({ direction: 'top', className: 'leaflet-tooltip-top-transport-parking' }, rest),
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                fontSize: '12px',
                bgcolor: 'background.paper',
                overflow: 'hidden',
                borderRadius: theme.shape.borderRadius,
                minWidth: '220px',
            }) },
            React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                    padding: theme.spacing(0),
                    bgcolor: 'background.default',
                    minHeight: '44px',
                    '.MuiTypography-root': {
                        whiteSpace: 'nowrap',
                        margin: theme.spacing(0),
                        width: '100%',
                        padding: theme.spacing(0),
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        fontSize: '13px',
                    },
                }) },
                React.createElement(Stack, { direction: 'row', sx: {
                        flexDirection: 'column',
                    } },
                    React.createElement(Typography, { variant: 'body1' }, value.name),
                    React.createElement(Typography, { variant: 'body1', sx: {
                            fontSize: '11px !important',
                        } }, "\u0421\u0442\u043E\u044F\u043D\u043A\u0430"))),
            React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                    display: 'grid',
                    gap: 2,
                    padding: theme.spacing(2),
                    '.MuiPaper-root': {
                        position: 'relative',
                        border: 'none',
                    },
                    '.MuiPaper-row': {
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(5, 1fr)',
                        '.MuiTypography-root:first-of-type': {
                            color: 'text.secondary',
                        },
                    },
                    '.MuiPaper-row .MuiTypography-root:first-of-type': {
                        gridRow: '1',
                        gridColumn: '1/3',
                    },
                    '.MuiPaper-row .MuiTypography-root:last-of-type': {
                        gridRow: '1',
                        gridColumn: '3/6',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        'span:nth-of-type(2)': {
                            paddingLeft: theme.spacing(0.5),
                        },
                    },
                }) },
                React.createElement(Paper, { variant: 'outlined' },
                    React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u0412\u0440\u0435\u043C\u044F:"),
                        React.createElement(Typography, { variant: 'body1' }, value.parking_time_start)),
                    value.interval && (React.createElement(Stack, { className: 'MuiPaper-row' },
                        React.createElement(Typography, { variant: 'body1' }, "\u0418\u043D\u0442\u0435\u0440\u0432\u0430\u043B:"),
                        React.createElement(Typography, { variant: 'body1' }, value.interval))))))));
};
export default MapLeafletTransportParkingTooltip;
